import * as React from 'react'
import { buttonClickHandlerFn } from './form-type-selector'
import { errorMsg } from './build-error-msg'

export function buildSubmitButton (data: any, buttonClickHandler: buttonClickHandlerFn): JSX.Element {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      buttonClickHandler(data.field_type)
    }
  }

  return <div className='col-xs-12' key={data.qid}>
    <div
      className={'button primary accentSecondary'}
      onClick={(e) => buttonClickHandler(data.field_type)}
      onKeyDown={handleKeyDown}
      role='button'
      tabIndex={0}
    >
      <span
        id={data.qid}
        className={data.className}
      >
        {data.value}
      </span>
    </div>
    {data.errorMessage &&
      errorMsg(data.qid, data.errorMessage)}
  </div>
}
